import { skillLevelLabels, skillLevelValue } from '@/constants/learning'
import type { SkillLevel } from '@/types'

interface SkillLevelBarProps {
  currentLevel: SkillLevel
  targetLevel?: SkillLevel | undefined
  size?: 'sm' | 'md' | undefined
}

const LEVELS: SkillLevel[] = ['beginner', 'intermediate', 'advanced', 'expert']

// Color scheme for each level segment
const LEVEL_COLORS: Record<SkillLevel, string> = {
  beginner: 'bg-blue-500',
  intermediate: 'bg-emerald-500',
  advanced: 'bg-amber-500',
  expert: 'bg-purple-500',
}

export function SkillLevelBar({ currentLevel, targetLevel, size = 'md' }: SkillLevelBarProps) {
  const currentValue = skillLevelValue[currentLevel]
  const targetValue = targetLevel ? skillLevelValue[targetLevel] : undefined
  const barHeight = size === 'sm' ? 'h-1.5' : 'h-2'

  return (
    <div className="w-full">
      <div className="flex gap-1">
        {LEVELS.map((level, i) => {
          const segmentValue = i + 1
          const isFilled = segmentValue <= currentValue
          const isTarget = targetValue !== undefined && segmentValue === targetValue

          return (
            <div key={level} className="relative flex-1">
              <div
                className={`${barHeight} rounded-sm transition-colors ${
                  isFilled ? LEVEL_COLORS[level] : 'bg-muted'
                }`}
              />
              {isTarget && segmentValue > currentValue && (
                <div
                  className="absolute -top-0.5 right-0 w-0.5 bg-primary/60"
                  style={{ height: size === 'sm' ? '10px' : '12px' }}
                />
              )}
            </div>
          )
        })}
      </div>
      {size === 'md' && (
        <div className="flex items-center justify-between mt-1">
          <span className="text-xs font-medium capitalize">{skillLevelLabels[currentLevel]}</span>
          {targetLevel && targetLevel !== currentLevel && (
            <span className="text-xs text-muted-foreground">
              Target: {skillLevelLabels[targetLevel]}
            </span>
          )}
        </div>
      )}
    </div>
  )
}
